import { render, staticRenderFns } from "./PageApply.vue?vue&type=template&id=f09bfc52&scoped=true&"
import script from "./PageApply.vue?vue&type=script&lang=js&"
export * from "./PageApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09bfc52",
  null
  
)

export default component.exports